module.exports = __webpack_public_path__ + "img/dynamic-9.dcac595b.png";